class ShopiPromos {
  constructor(store) {
    this._store = store

    setInterval(() => {
      promos.getPromos()
    }, 3000);
  }

  getPromos() {
    fetch(`https://shopipromos.appsthechemistlook.com/promos?store=${this._store}`, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json"
      }
    }).then(response => response.text())
    .then(result => {

      if (window) {
        if (window.$Cart === undefined) {
          setInterval( () => {
            this.promoValidator(JSON.parse(result))
          }, 3000 )
        } else {
          this.promoValidator(JSON.parse(result))
        }
      }
    })
    .catch(error => console.log('error', error))
  }

  async promoValidator(promos) {
    const today = new Date().getTime()
    const currentCart = await $Cart.get()

    const insertAfter = function(tag, classString, template, target) {
      const newNode = document.createElement(tag)
            newNode.classList.add(classString)
            newNode.innerHTML = template
            if(target){
              target.parentNode.insertBefore(newNode, target.nextSibling)
            }
    }

    function subtractHours(date, hours) {
      date.setHours(date.getHours() - hours);
    
      return date;
    }

    promos.forEach(promo => {
      if (promo && promo.status == 1) {
        
        let promoDataObj = {}

        let promoDateConditional = true
        if (promo.data.includes('{')) {
          promoDataObj = JSON.parse(promo.data)
          if (promoDataObj && promoDataObj.enableAutoEnable == false) {
            promoDateConditional = false
          }
        }

        if(
          (today <= promo.active_date_to && today >= promo.active_date_from) || 
          promoDateConditional === false || 
          true
        ) {
          const data = JSON.parse(promo.data)
          console.log("Promo:", promoDataObj)
          
          
          if (promo && promo.type == 'gift_product_by_items') {
            const productsIf = data['ifAddThis']
            const productsToAdd = data['doIt']['products']
            let a = currentCart.items.map(a => a.variant_id)
            let b = productsIf.map(b => b.variantID)
            let c = productsToAdd.map(c => c.variantID)
            let hasPromo = b.every(function(val) { return a.indexOf(val) >= 0 })

            if (hasPromo) {
              console.log("Promo valida")
              const list = []

              productsToAdd.forEach(prod => {
                if (!a.includes(prod.variantID)) {
                  list.push({
                    id: prod.variantID,
                    quantity: 1,
                    properties: {
                      "itsFree": "true"
                    }
                  })
                }
              })

              if (list[0]) $Cart.addItem(list, false)
              
            } else {
              console.log("Promo no valida")
              productsToAdd.forEach(prod => {
                if (a.includes(prod.variantID)) {

                  $Cart.removeItem(prod.variantID)
                }
              })
            }
            
            currentCart.items.forEach(cartItem => {
              if (cartItem.price == 0 && a.includes(cartItem.variant_id) && !c.includes(cartItem.variant_id)) {
                $Cart.removeItem(cartItem.variant_id)
              }
            })
          }

          if (promo && promo.type == 'gift_product_by_items_from_colections') {
            console.log("Promo by collections")
            const productsIf = data['ifAddThis']
            const productsToAdd = data['doIt']['products']
            let a = currentCart.items.map(a => a.variant_id)
            let b = productsIf.map(b => b.variantID)
            let c = productsToAdd.map(c => c.variantID)
            
            let hasPromo = false

            if (promoDataObj.numberCollection === 0) {
              hasPromo = b.every(function(val) { return a.indexOf(val) >= 0 })
            } else {
              let pusher = []
              for (let i = 0; i < a.length; i++) {
                const cartItem = a[i]

                if (b.includes(cartItem)) {
                  pusher.push(cartItem)

                  if (promoDataObj.enableqnty) {
                    console.log("Sumar cantidad del elemento...")
                    let m = currentCart.items.filter(item => item.variant_id === cartItem)
                    if (m && m[0] && m[0].quantity === 2) pusher.push(cartItem+23)
                    if (m && m[0] && m[0].quantity === 3) {
                      pusher.push(cartItem+54)
                      pusher.push(cartItem+98)
                    }
                  }
                }
              }

              if (pusher.length >= promoDataObj.numberCollection) {
                hasPromo = true
              } else {
                hasPromo = false
              }
            }

            if (hasPromo) {
              const list = []

              productsToAdd.forEach(prod => {
                if (!a.includes(prod.variantID)) {
                  list.push({
                    id: prod.variantID,
                    quantity: 1,
                    properties: {
                      "itsFree": "true"
                    }
                  })
                }
              })

              console.log("Add this:", list)
              if (list[0]) $Cart.addItem(list, false)
              
            } else {
              productsToAdd.forEach(prod => {
                if (a.includes(prod.variantID)) {

                  $Cart.removeItem(prod.variantID)
                }
              })
            }
            
            
            currentCart.items.forEach(cartItem => {

              if (promoDataObj.numberCollection === 0) {
                if (cartItem.price == 0 && a.includes(cartItem.variant_id) && !c.includes(cartItem.variant_id)) {
                  $Cart.removeItem(cartItem.variant_id)
                }
              } else {

              }
              
            })
          }

          if (promo && promo.type == 'gift_discount_by_total_amount') {
            let currentAmount = currentCart.total_price / 100

            if (currentAmount >= promoDataObj.minTotal) {
              const productsToAdd = data['ifAddThis']
              let a = currentCart.items.map(a => a.variant_id)
              
              let addProduct = true
              for (let i = 0; i < currentCart.items.length; i++) {
                const cartItem = currentCart.items[i]
                if (cartItem.properties?.hasDiscount) {
                  addProduct = false
                }
              }

              if (addProduct) {
                const list = []
                productsToAdd.forEach(prod => {
                  if (!a.includes(prod.variantID)) {
                    list.push({
                      id: prod.variantID,
                      quantity: 1,
                      properties: {
                        "hasDiscount": "true",
                        "discount": promoDataObj.minTotalAmount
                      }
                    })
                  }
                })
                console.log("Add this:", list)
                if (list[0]) $Cart.addItem(list, false)
              }

            } else {
              console.log("La promo NO es valida...")
              let removeProduct = false
              for (let i = 0; i < currentCart.items.length; i++) {
                const cartItem = currentCart.items[i]
                if (cartItem.properties?.hasDiscount) {
                  removeProduct = cartItem.variant_id
                }
              }
              if (removeProduct) {
                $Cart.removeItem(removeProduct)
              }

            }
           
          }

          if (promo && promo.type == 'gift_discount_by_quantity_items') {
            let currentAmount = currentCart.item_count

            if (currentAmount >= promoDataObj.minTotal) {
              const productsToAdd = data['ifAddThis']
              let a = currentCart.items.map(a => a.variant_id)
              
              let addProduct = true
              for (let i = 0; i < currentCart.items.length; i++) {
                const cartItem = currentCart.items[i]
                if (cartItem.properties?.hasDiscount) {
                  addProduct = false
                }
              }

              if (addProduct) {
                const list = []
                productsToAdd.forEach(prod => {
                  if (!a.includes(prod.variantID)) {
                    list.push({
                      id: prod.variantID,
                      quantity: 1,
                      properties: {
                        "hasDiscount": "true",
                        "discount": promoDataObj.minTotalAmount
                      }
                    })
                  }
                })
                if (list[0]) $Cart.addItem(list, false)
              }

            } else {
              console.log("La promo 2 NO es valida...")
              let removeProduct = false
              for (let i = 0; i < currentCart.items.length; i++) {
                const cartItem = currentCart.items[i]
                if (cartItem.properties?.hasDiscount) {
                  removeProduct = cartItem.variant_id
                }
              }
              if (removeProduct) {
                $Cart.removeItem(removeProduct)
              }

            }
           
          }

        }
      }
    })
  }

}

const promos = new ShopiPromos(Shopify.shop)
promos.getPromos()